import React from 'react';
import {observer} from 'mobx-react'
import { GlobalTaskNotificationsTemplate } from 'themes/application/global-task-notifications/components';
import { GlobalTaskNotificationsStore } from 'application/global-task-notifications/stores';
import { setCurrentView } from 'core/utils';

@setCurrentView((rootStore) => new GlobalTaskNotificationsStore(rootStore), 'globalTaskNotificationsStore')
@observer
class GlobalTaskNotifications extends React.Component {
    render(){
        return <GlobalTaskNotificationsTemplate {...this.props} />
    }
}

export default GlobalTaskNotifications;